<p-dialog
  header="Clone Profile"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{ width: '30vw' }"
  (onHide)="close()">

  <form [formGroup]="cloneForm">
    <div class="p-fluid">
      <div class="p-field p-mb-3">
        <label for="orgField">Target Organization <span class="required">*</span></label>
        <p-dropdown
          id="orgField"
          [options]="orgs"
          formControlName="targetOrganizationId"
          placeholder="Select an Organization"
          optionLabel="name"
          optionValue="id"
          appendTo="body"
          [showClear]="true"
          [filter]="true"
          filterBy="name"
          filterPlaceholder="Search orgs"
          [resetFilterOnHide]="true"
          [class.ng-invalid]="cloneForm.get('targetOrganizationId')?.invalid && cloneForm.get('targetOrganizationId')?.touched">
        </p-dropdown>

        <small
          class="p-error"
          *ngIf="cloneForm.get('targetOrganizationId')?.invalid && cloneForm.get('targetOrganizationId')?.touched">
          Organization is required.
        </small>
      </div>

      <div class="p-field p-mb-3">
        <label for="newProfileName">New Profile Name </label>
        <input id="newProfileName" type="text" formControlName="newProfileName" pInputText required/>
        <small class="p-error" *ngIf="cloneForm.get('newProfileName')?.errors?.required">
          Profile Name is required.
        </small>
        <small class="p-error" *ngIf="cloneForm.get('newProfileName')?.errors?.nameValidator">
          Profile Name is invalid.
        </small>
        <small class="p-error" *ngIf="cloneForm.get('newProfileName')?.errors?.minlength">
          Profile Name must be at least 5 characters long.
        </small>
        <small class="p-error" *ngIf="cloneForm.get('newProfileName')?.errors?.maxlength">
          Profile Name must be at most 20 characters long.
        </small>
        <small
          class="p-error"
          *ngIf="cloneForm.errors?.uniqueProfileNameInOrg && (cloneForm.get('newProfileName')?.dirty || cloneForm.get('newProfileName')?.touched)">
          A profile with this name already exists in this organization.
        </small>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-text"
      (click)="close()">
    </button>

    <button
      pButton
      type="button"
      label="Clone"
      icon="fas fa-copy"
      class="p-button-secondary"
      (click)="confirmClone()"
      [disabled]="cloneForm.invalid">
    </button>
  </ng-template>
</p-dialog>
